import React from 'react';

interface IntroContainerProps {
  children: React.ReactNode;
}

const IntroContainer = (props: IntroContainerProps) => {
  return <div>ekk</div>;
};

export default IntroContainer;
